import { render, staticRenderFns } from "./NewsVideo.vue?vue&type=template&id=72ec22b3&scoped=true"
import script from "./NewsVideo.vue?vue&type=script&lang=js"
export * from "./NewsVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ec22b3",
  null
  
)

export default component.exports